"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPlsUrl = void 0;
var pathnameRegExp = /^\/(pls_track|cta_click)\/?$/;

var isPlsUrl = function isPlsUrl(url) {
  if (!url) {
    return false;
  }

  if (!(url instanceof URL)) {
    try {
      url = new URL(url);
    } catch (_unused) {
      return false;
    }
  }

  return pathnameRegExp.test(url.pathname);
};

exports.isPlsUrl = isPlsUrl;
//# sourceMappingURL=is-pls-url.js.map